<div class="loading-screen-wrapper">
    <div class="loading-screen-icon">
      <div class="blobs">
        <div class="blob">
          <img src="./assets/images/loader-img.gif" alt = "Loading">
          <p> {{'LS.LOADING' | translate}} </p>
        </div>
      </div>
    </div>
  </div>